module.exports = __webpack_public_path__ + "img/logo-dark.dc29c782.png";